import { getIwocaPayMeUrl } from '../../../../../components/PayMeLink/getIwocaPayMeUrl';
import { displayCurrency } from '../../../../../utils/DisplayCurrency';
import { getFormattedDate } from '../../../../../utils/DisplayDate';
import { PackageLink } from '../../PackageLinksPage.types';

export type PackageLinkTableRow = {
  package_id: string;
  name: string;
  amount: string;
  reference: string;
  dateCreated: string;
  payLinkUrl: string;
  selectedRows: string[];
  handleAddSelectedRow: (packageIds: string[]) => void;
  handleRemoveSelectedRow: (packageIds: string[]) => void;
};

export const normalisePackageLinkTableData = ({
  packageLinks,
  sellerHandle,
  selectedRows,
  handleAddSelectedRow,
  handleRemoveSelectedRow,
}: {
  packageLinks: PackageLink[];
  sellerHandle: string;
  selectedRows: string[];
  handleAddSelectedRow: (packageIds: string[]) => void;
  handleRemoveSelectedRow: (packageIds: string[]) => void;
}): PackageLinkTableRow[] => {
  return packageLinks.map((packageLink) => {
    const trimmedReference = packageLink.reference?.trim();
    return {
      package_id: packageLink.id,
      name: packageLink.name,
      amount:
        packageLink.amount !== null && packageLink.amount !== undefined
          ? displayCurrency(packageLink.amount)
          : 'Customer input',
      reference: trimmedReference ? trimmedReference : 'Customer input',
      dateCreated: getFormattedDate(packageLink.created_at),
      payLinkUrl: getIwocaPayMeUrl(sellerHandle, packageLink.id),
      selectedRows,
      handleAddSelectedRow,
      handleRemoveSelectedRow,
    };
  });
};
